"use strict";function openBindIDCard$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openBindIDCard$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.verify.openBindIDCard";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.21"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.21"},_a)),exports.openBindIDCard$=openBindIDCard$,exports.default=openBindIDCard$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/verify/openBindIDCard.js
// module id = 1036
// module chunks = 106